import React from 'react'

const iconProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
  focusable: false as const,
}

export const DrawRulerIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M3 3.00001H9V13.4004C9.00021 14.2838 9.71624 14.9998 10.5996 15H21V21H3V3.00001ZM23 14.5996C22.9998 13.7163 22.2838 13.0002 21.4004 13H11V2.59962C10.9998 1.71621 10.2837 1.00022 9.40039 1.00001H2.59961C1.7163 1.00022 1.00021 1.71621 1 2.59962V21.4004C1.00021 22.2837 1.71627 22.9998 2.59961 23H21.4004C22.2838 22.9998 22.9998 22.2837 23 21.4004V14.5996Z"
      fill="currentColor"
    />
    <path
      d="M14.9988 14.0016V17.0016C14.9988 17.5538 15.4465 18.0016 15.9988 18.0016C16.5511 18.0016 16.9988 17.5538 16.9988 17.0016V14.0016C16.9988 13.4493 16.5511 13.0016 15.9988 13.0016C15.4465 13.0016 14.9988 13.4493 14.9988 14.0016Z"
      fill="currentColor"
    />
    <path
      d="M8.99883 14.0016V17.0016C8.99883 17.5538 9.44654 18.0016 9.99883 18.0016C10.5511 18.0016 10.9988 17.5538 10.9988 17.0016V14.0016C10.9988 13.4493 10.5511 13.0016 9.99883 13.0016C9.44654 13.0016 8.99883 13.4493 8.99883 14.0016Z"
      fill="currentColor"
    />
    <path
      d="M9.99883 9.00156C10.5511 9.00156 10.9988 8.55385 10.9988 8.00156C10.9988 7.44928 10.5511 7.00156 9.99883 7.00156H6.99883C6.44654 7.00156 5.99883 7.44928 5.99883 8.00156C5.99883 8.55385 6.44654 9.00156 6.99883 9.00156H9.99883Z"
      fill="currentColor"
    />
    <path
      d="M9.99883 15.0016C10.5511 15.0016 10.9988 14.5538 10.9988 14.0016C10.9988 13.4493 10.5511 13.0016 9.99883 13.0016H6.99883C6.44654 13.0016 5.99883 13.4493 5.99883 14.0016C5.99883 14.5538 6.44654 15.0016 6.99883 15.0016H9.99883Z"
      fill="currentColor"
    />
  </svg>
)
export const DrawLineIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M20.2928 2.29297C20.6833 1.90244 21.3164 1.90244 21.7069 2.29297C22.0974 2.68349 22.0974 3.31651 21.7069 3.70703L3.70688 21.707C3.31635 22.0976 2.68334 22.0976 2.29282 21.707C1.90229 21.3165 1.90229 20.6835 2.29282 20.293L20.2928 2.29297Z"
      fill="currentColor"
    />
    <path
      d="M20 3C20 3.55228 20.4477 4 21 4C21.5523 4 22 3.55228 22 3C22 2.44772 21.5523 2 21 2C20.4477 2 20 2.44772 20 3Z"
      fill="currentColor"
    />
    <path
      d="M21 1C22.1046 1 23 1.89544 23 3C23 4.10457 22.1046 5 21 5C19.8954 5 19 4.10456 19 3C19 1.89544 19.8954 1 21 1Z"
      fill="currentColor"
    />
    <path
      d="M2 21C2 21.5523 2.4477 22 3 22C3.5523 22 4 21.5523 4 21C4 20.4477 3.5523 20 3 20C2.4477 20 2 20.4477 2 21Z"
      fill="currentColor"
    />
    <path
      d="M3 19C4.10458 19 5 19.8954 5 21C5 22.1046 4.10458 23 3 23C1.89542 23 1 22.1046 1 21C1 19.8954 1.89542 19 3 19Z"
      fill="currentColor"
    />
  </svg>
)
export const DrawPolygonIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M4 20H20V4H4V20ZM22 20.4004C21.9998 21.2838 21.2838 21.9998 20.4004 22H3.59961C2.7163 21.9998 2.00021 21.2838 2 20.4004V3.59961C2.00021 2.71626 2.71626 2.00021 3.59961 2H20.4004C21.2838 2.00021 21.9998 2.7163 22 3.59961V20.4004Z"
      fill="currentColor"
    />
    <path
      d="M3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4Z"
      fill="currentColor"
    />
    <path
      d="M1 3C1 1.89544 1.89544 1 3 1C4.10456 1 5 1.89544 5 3C5 4.10456 4.10456 5 3 5C1.89544 5 1 4.10456 1 3Z"
      fill="currentColor"
    />
    <path
      d="M21 22C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20C20.4477 20 20 20.4477 20 21C20 21.5523 20.4477 22 21 22Z"
      fill="currentColor"
    />
    <path
      d="M19 21C19 19.8954 19.8954 19 21 19C22.1046 19 23 19.8954 23 21C23 22.1046 22.1046 23 21 23C19.8954 23 19 22.1046 19 21Z"
      fill="currentColor"
    />
  </svg>
)
export const Draw3DIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M12 23C12.5523 23 13 22.5523 13 22C13 21.4477 12.5523 21 12 21C11.4477 21 11 21.4477 11 22C11 22.5523 11.4477 23 12 23Z"
      fill="currentColor"
    />
    <path
      d="M10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22C14 23.1046 13.1046 24 12 24C10.8954 24 10 23.1046 10 22Z"
      fill="currentColor"
    />
    <path
      d="M3 8C3.55228 8 4 7.55228 4 7C4 6.44772 3.55228 6 3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8Z"
      fill="currentColor"
    />
    <path
      d="M1 7C1 5.89544 1.89544 5 3 5C4.10456 5 5 5.89544 5 7C5 8.10456 4.10456 9 3 9C1.89544 9 1 8.10456 1 7Z"
      fill="currentColor"
    />
    <path
      d="M3 18C3.55228 18 4 17.5523 4 17C4 16.4477 3.55228 16 3 16C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18Z"
      fill="currentColor"
    />
    <path
      d="M1 17C1 15.8954 1.89545 15 3 15C4.10455 15 5 15.8954 5 17C5 18.1046 4.10455 19 3 19C1.89545 19 1 18.1046 1 17Z"
      fill="currentColor"
    />
    <path
      d="M3.99998 7.58735V16.4116L12 20.8559L20 16.4116V7.58735L12 3.14302L3.99998 7.58735ZM22 16.6469C22 17.2279 21.6852 17.7631 21.1777 18.0454H21.1767L12.7773 22.7124C12.294 22.9809 11.7059 22.9809 11.2226 22.7124L2.82322 18.0454H2.82225C2.31498 17.7631 1.99998 17.228 1.99998 16.6469V7.35298C2 6.77192 2.3153 6.23671 2.82322 5.95454L11.2226 1.28755L11.4082 1.19966C11.788 1.04844 12.212 1.04844 12.5918 1.19966L12.7773 1.28755L21.1767 5.95454C21.6843 6.23664 22 6.77179 22 7.35298V16.6469Z"
      fill="currentColor"
    />
    <path
      d="M20.0148 6.40381C20.4975 6.1358 21.106 6.30978 21.3741 6.79248C21.6422 7.27523 21.4682 7.88368 20.9855 8.15185L12.7775 12.7124H12.7765C12.3539 12.9469 11.8518 12.9761 11.4093 12.8003L11.2228 12.7124L3.04309 8.16748C2.56032 7.89927 2.38623 7.29088 2.65442 6.8081C2.92259 6.3254 3.53105 6.15141 4.01379 6.41943L12.0001 10.856L20.0148 6.40381Z"
      fill="currentColor"
    />
    <path
      d="M11 21V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21Z"
      fill="currentColor"
    />
  </svg>
)
export const DrawTrashIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M19.0146 8.82715C19.1103 8.28334 19.6291 7.91925 20.1729 8.01465C20.7167 8.11027 21.0807 8.62905 20.9854 9.17285L18.9902 20.5195C18.7381 21.954 17.4915 23 16.0352 23H7.96484C6.5084 23 5.26197 21.9539 5.00977 20.5195L3.01465 9.17285C2.91925 8.62905 3.28334 8.11026 3.82715 8.01465C4.37095 7.91925 4.88974 8.28334 4.98535 8.82715L6.97949 20.1729C7.06357 20.651 7.47939 21 7.96484 21H16.0352C16.5206 21 16.9365 20.651 17.0205 20.1729L19.0146 8.82715Z"
      fill="currentColor"
    />
    <path
      d="M14.375 4C14.375 3.44771 13.9273 3 13.375 3H10.625C10.0727 3 9.625 3.44771 9.625 4V5H14.375V4ZM16.375 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7.625V4C7.625 2.34315 8.96815 1 10.625 1H13.375C15.0319 1 16.375 2.34315 16.375 4V5Z"
      fill="currentColor"
    />
  </svg>
)
export const DrawPrintIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M22 17.4004C21.9998 18.2838 21.2838 18.9998 20.4004 19H17.5713V17H20V11C20 9.34315 18.6568 8 17 8H7C5.34314 8 4 9.34314 4 11V17H6.42871V19H3.59961C2.7163 18.9998 2.00021 18.2838 2 17.4004V11C2 8.23858 4.23858 6 7 6H17C19.7614 6 22 8.23857 22 11V17.4004Z"
      fill="currentColor"
    />
    <path
      d="M17 7H15V4H9V7H7V3.59961C7.00021 2.71626 7.71627 2.00021 8.59961 2H15.4004C16.2838 2.00021 16.9998 2.7163 17 3.59961V7Z"
      fill="currentColor"
    />
    <path
      d="M16.4794 13C17.2757 13 17.9504 13.5855 18.0634 14.373L18.8925 20.1738C19.0301 21.1376 18.2819 21.9998 17.3085 22H6.69226C5.71856 22 4.97064 21.1377 5.10828 20.1738L5.9364 14.374L5.96375 14.2285C6.13354 13.5147 6.77381 13 7.52039 13H16.4794ZM7.1532 20H16.8466L16.1327 15H7.86707L7.1532 20Z"
      fill="currentColor"
    />
    <path
      d="M16.2666 9.32994C16.636 8.91949 17.2682 8.88635 17.6787 9.25573C18.0892 9.6252 18.1224 10.2573 17.7529 10.6678L17.7432 10.6786C17.3737 11.0891 16.7415 11.1223 16.3311 10.7528C15.9208 10.3833 15.8874 9.75111 16.2568 9.34069L16.2666 9.32994Z"
      fill="currentColor"
    />
  </svg>
)
